"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es.array.sort.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Options_instances, _Options_findDefaultTheme;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = void 0;

var Interactivity_1 = require("./Interactivity/Interactivity");

var ParticlesOptions_1 = require("./Particles/ParticlesOptions");

var BackgroundMask_1 = require("./BackgroundMask/BackgroundMask");

var Background_1 = require("./Background/Background");

var Utils_1 = require("../../Utils");

var Theme_1 = require("./Theme/Theme");

var Enums_1 = require("../../Enums");

var FullScreen_1 = require("./FullScreen/FullScreen");

var Motion_1 = require("./Motion/Motion");

var ManualParticle_1 = require("./ManualParticle");

var Responsive_1 = require("./Responsive");

var Options = /*#__PURE__*/function () {
  function Options() {
    _classCallCheck(this, Options);

    _Options_instances.add(this);

    this.autoPlay = true;
    this.background = new Background_1.Background();
    this.backgroundMask = new BackgroundMask_1.BackgroundMask();
    this.fullScreen = new FullScreen_1.FullScreen();
    this.detectRetina = true;
    this.duration = 0;
    this.fpsLimit = 60;
    this.interactivity = new Interactivity_1.Interactivity();
    this.manualParticles = [];
    this.motion = new Motion_1.Motion();
    this.particles = new ParticlesOptions_1.ParticlesOptions();
    this.pauseOnBlur = true;
    this.pauseOnOutsideViewport = true;
    this.responsive = [];
    this.themes = [];
    this.zLayers = 100;
  }

  _createClass(Options, [{
    key: "fps_limit",
    get: function get() {
      return this.fpsLimit;
    },
    set: function set(value) {
      this.fpsLimit = value;
    }
  }, {
    key: "retina_detect",
    get: function get() {
      return this.detectRetina;
    },
    set: function set(value) {
      this.detectRetina = value;
    }
  }, {
    key: "backgroundMode",
    get: function get() {
      return this.fullScreen;
    },
    set: function set(value) {
      this.fullScreen.load(value);
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d, _e;

      if (data === undefined) {
        return;
      }

      if (data.preset !== undefined) {
        if (data.preset instanceof Array) {
          var _iterator = _createForOfIteratorHelper(data.preset),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var preset = _step.value;
              this.importPreset(preset);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          this.importPreset(data.preset);
        }
      }

      if (data.autoPlay !== undefined) {
        this.autoPlay = data.autoPlay;
      }

      var detectRetina = (_a = data.detectRetina) !== null && _a !== void 0 ? _a : data.retina_detect;

      if (detectRetina !== undefined) {
        this.detectRetina = detectRetina;
      }

      if (data.duration !== undefined) {
        this.duration = data.duration;
      }

      var fpsLimit = (_b = data.fpsLimit) !== null && _b !== void 0 ? _b : data.fps_limit;

      if (fpsLimit !== undefined) {
        this.fpsLimit = fpsLimit;
      }

      if (data.pauseOnBlur !== undefined) {
        this.pauseOnBlur = data.pauseOnBlur;
      }

      if (data.pauseOnOutsideViewport !== undefined) {
        this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
      }

      if (data.zLayers !== undefined) {
        this.zLayers = data.zLayers;
      }

      this.background.load(data.background);
      var fullScreen = (_c = data.fullScreen) !== null && _c !== void 0 ? _c : data.backgroundMode;

      if (typeof fullScreen === "boolean") {
        this.fullScreen.enable = fullScreen;
      } else {
        this.fullScreen.load(fullScreen);
      }

      this.backgroundMask.load(data.backgroundMask);
      this.interactivity.load(data.interactivity);

      if (data.manualParticles !== undefined) {
        this.manualParticles = data.manualParticles.map(function (t) {
          var tmp = new ManualParticle_1.ManualParticle();
          tmp.load(t);
          return tmp;
        });
      }

      this.motion.load(data.motion);
      this.particles.load(data.particles);
      Utils_1.Plugins.loadOptions(this, data);

      if (data.responsive !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(data.responsive),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var responsive = _step2.value;
            var optResponsive = new Responsive_1.Responsive();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.responsive.sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
      });

      if (data.themes !== undefined) {
        var _iterator3 = _createForOfIteratorHelper(data.themes),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var theme = _step3.value;
            var optTheme = new Theme_1.Theme();
            optTheme.load(theme);
            this.themes.push(optTheme);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      this.defaultDarkTheme = (_d = __classPrivateFieldGet(this, _Options_instances, "m", _Options_findDefaultTheme).call(this, Enums_1.ThemeMode.dark)) === null || _d === void 0 ? void 0 : _d.name;
      this.defaultLightTheme = (_e = __classPrivateFieldGet(this, _Options_instances, "m", _Options_findDefaultTheme).call(this, Enums_1.ThemeMode.light)) === null || _e === void 0 ? void 0 : _e.name;
    }
  }, {
    key: "setTheme",
    value: function setTheme(name) {
      if (name) {
        var chosenTheme = this.themes.find(function (theme) {
          return theme.name === name;
        });

        if (chosenTheme) {
          this.load(chosenTheme.options);
        }
      } else {
        var mediaMatch = typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)"),
            clientDarkMode = mediaMatch && mediaMatch.matches,
            defaultTheme = __classPrivateFieldGet(this, _Options_instances, "m", _Options_findDefaultTheme).call(this, clientDarkMode ? Enums_1.ThemeMode.dark : Enums_1.ThemeMode.light);

        if (defaultTheme) {
          this.load(defaultTheme.options);
        }
      }
    }
  }, {
    key: "setResponsive",
    value: function setResponsive(width, pxRatio, defaultOptions) {
      var _a;

      this.load(defaultOptions);
      this.load((_a = this.responsive.find(function (t) {
        return t.maxWidth * pxRatio > width;
      })) === null || _a === void 0 ? void 0 : _a.options);
    }
  }, {
    key: "importPreset",
    value: function importPreset(preset) {
      this.load(Utils_1.Plugins.getPreset(preset));
    }
  }]);

  return Options;
}();

exports.Options = Options;
_Options_instances = new WeakSet(), _Options_findDefaultTheme = function _Options_findDefaultTheme(mode) {
  var _a;

  return (_a = this.themes.find(function (theme) {
    return theme.default.value && theme.default.mode === mode;
  })) !== null && _a !== void 0 ? _a : this.themes.find(function (theme) {
    return theme.default.value && theme.default.mode === Enums_1.ThemeMode.any;
  });
};